import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExtractionsReportService } from 'src/app/services/extractions-report.service';

@Component({
  selector: 'app-extractions-reports',
  templateUrl: './extractions-reports.component.html',
  styleUrls: ['./extractions-reports.component.scss']
})
export class ExtractionsReportsComponent {
  isOpen = true;
  btnExcel = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnPdf = new ButtonLoading("btn-primary", false, "", "fa fa-file-pdf");
  lastDownloadDate: Date | null = null;
  startDate = '';
  endDate = '';

  constructor(
    private extractionsReportService: ExtractionsReportService,
    private toast: ToastrService
  ) {
    const today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    this.startDate = today.toLocaleDateString('en-CA');
  }

  toggleSection() {
    this.isOpen = !this.isOpen;
  }

  downloadReport(type: string) {
    const button = type === 'excel' ? this.btnExcel : this.btnPdf;
    if (button.loading) return;
    button.loading = true;

    this.extractionsReportService.getEntryNoteReport(type, this.getDateLong(this.startDate), this.getDateLong(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, 'Reporte de Notas de Ingreso');
        this.toast.success('Reporte descargado correctamente');
        this.lastDownloadDate = new Date();
        button.loading = false;
      },
      error: () => {
        this.toast.error('Error al descargar el reporte');
        button.loading = false;
      }
    });
  }

  downloadReportExitNote(type: string) {
    const button = type === 'excel' ? this.btnExcel : this.btnPdf;
    if (button.loading) return;
    button.loading = true;

    this.extractionsReportService.getExitNoteReport(type, this.getDateLong(this.startDate), this.getDateLong(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, 'Reporte de Notas de Despacho');
        this.toast.success('Reporte descargado correctamente');
        this.lastDownloadDate = new Date();
        button.loading = false;
      },
      error: () => {
        this.toast.error('Error al descargar el reporte');
        button.loading = false;
      }
    });
  }

  private downloadFile(base64: string, type: string, filename: string) {
    const fileBytes = Uint8Array.from(atob(base64), c => c.charCodeAt(0));
    const blob = new Blob([fileBytes], {
      type: type === 'pdf'
        ? 'application/pdf'
        : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = `${filename}.${type === 'pdf' ? 'pdf' : 'xlsx'}`;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  getDateLong(stringDate: string): number {
      return DateUtil.parseDateToMilliseconds(stringDate);
    }
}
